export default __webpack_public_path__ + "static/media/insta15.0003cb20.webp";